import { atom } from 'recoil';

export const appointmentStatusesArchiveModalStateAtom = atom({
  key: 'appointmentStatusesArchiveStateAtom',
  default: { open: false, appointmentId: '' },
});
